import styled from "styled-components"

export const SocialNetworks = styled.div`
  display: grid;
  column-gap: 25px;
  grid-template-columns: repeat(4, 16px);
  justify-content: center;
`
